import { useRecoilState, useResetRecoilState } from 'recoil';
import { BottomDrawerComponentType } from './types';
import { bottomDrawerAtom } from './atom';

type Params = {
  drawerContentType: BottomDrawerComponentType;
  drawerComponentProps?: any;
  onClose?: () => void;
};

export const useBottomDrawer = () => {
  const [bottomDrawer, setBottomDrawer] = useRecoilState(bottomDrawerAtom);
  const resetState = useResetRecoilState(bottomDrawerAtom);

  const openBottomDrawer = (params?: Params) => {
    const { drawerComponentProps, drawerContentType, onClose } = params || {};

    setBottomDrawer((prev) => ({
      ...prev,
      isOpen: true,
      drawerComponentProps,
      drawerContentType,
      onClose: onClose
    }));
  };

  const closeBottomDrawer = () => {
    if (bottomDrawer.onClose) {
      bottomDrawer.onClose();
    }
    resetState();
  };

  const updateBottomDrawerComponentProps = (
    drawerComponentProps: Record<string, any>
  ) => {
    setBottomDrawer((prev) => ({
      ...prev,
      drawerComponentProps: {
        ...prev.drawerComponentProps,
        ...drawerComponentProps
      }
    }));
  };

  const updateBottomDrawerProps = (drawerProps: { preventClose: boolean }) => {
    setBottomDrawer((prev) => ({
      ...prev,
      ...drawerProps
    }));
  };

  return {
    ...bottomDrawer,
    closeBottomDrawer,
    openBottomDrawer,
    updateBottomDrawerComponentProps,
    updateBottomDrawerProps
  };
};
